import { API_URL } from "../../constants/app";
import { headersJson, headersJsonToken } from "./requestHeaders";

export async function addUserDeleteRequest(payload) {
	let res = await fetch(`${API_URL}/user-mobile-delete-request/request?reasonId=${payload.reasonId}&type=${payload.type}&username=${payload.username}`, {
		method: "POST",
		headers: headersJson(),
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}

export async function getInfiniteUserDeleteRequest({ queryKey, pageParam = 1 }) {
	let payload = queryKey[1];
	payload = { page: pageParam, ...payload };
	let res = await fetch(`${API_URL}/user-mobile-delete-request/list`, {
	  method: "POST",
	  headers: headersJsonToken(),
	  body: JSON.stringify(payload),
	})
	  .then((res) => res.json())
	  .then((data) => {
		let modifiedData = [];
		data.body.data.forEach((val, i) => {
			modifiedData.push({
				n: i + 1,
				id: val.id,
				username: val.username,
				userMobileDeleteReasonName: val.userMobileDeleteReasonName,
				type: val.type === 1 ? "Phone Number" : "Gmail",
				status: val.status,
				approvedBy: val.approvedBy,
				approved: val.approved,
				rejectedBy: val.rejectedBy,
				rejected: val.rejected,
				created: val.created,
				createdBy: val.createdBy
			})
		})
		return { modifiedData, pagination: data.body.pagination };
	  });
	return res;
}

export async function updateStatusUserDeleteRequest(payload) {
	let res = await fetch(`${API_URL}/user-mobile-delete-request/update-status?id=${payload.id}&status=${payload.status}`, {
	  method: "POST",
	  headers: headersJsonToken(),
	})
	  .then((res) => res.json())
	  .then((data) => {
		return data;
	  });
	return res;
}

  
